import { logger } from "@/utils/log";
import QueryString from "qs"

export function getVendorsProducts() {
  try {
    return window.__ZM_BILLING_SHARED?.apis?.getVendorsProducts() || Promise.resolve(null)
  } catch (error) {
    logger.error('getVendorsProducts error', error);
    return Promise.resolve(null)
  }
}

export function getDeskPhoneIdInLink() {
  const params = QueryString.parse(location.search.slice(1));
  return params.dpid
}

export function isBuyVendorLink() {
  return !!getDeskPhoneIdInLink()
}

export function addVendorProduct(allPlans) {
  const dpID = getDeskPhoneIdInLink();
  if (dpID) {
    allPlans.forEach(item => {
      if (item.isVendorProduct) {
        if (item.plan_code == dpID) {
          item.cartInfo.selected_number = 1
        }
      }
    })
  }
  return allPlans
}
